import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { mapRegionSchema } from '../schemas/map-region.schema';
import { mapSetSchema } from '../schemas/map-set.schema';

/**
 * Retrieves a paginated response for Map Sets
 * @param params Paged Collection Params
 * @returns Paged Collection of Map Sets
 */
export function getMapSets(this: unknown, params?: PagedCollectionParams) {
  const requestUrl = `${fleetEnvironment.resolve(this).mapSetsUrl}?${
    params ? params.urlParams : ''
  }`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      createPagedCollectionSchema(
        mapSetSchema.extend({
          mapRegions: z.array(mapRegionSchema),
        })
      )
    )
  );
}
